import { useContext } from 'react';
import { NotificationsContext } from 'pos-client/contexts/NotificationsContext.tsx';

export function useNotifications() {
  const context = useContext(NotificationsContext);

  return context;
}
